module.exports = __webpack_public_path__ + "static/media/vectorStar.e76c2de1.svg";